import BannerItem from "@components/bannerItem";
import { organizeBanners } from "@utils/array";
import React, { useEffect, useMemo, useRef } from "react";
import { getActiveLanguage } from "react-localize-redux";
import { connect } from "react-redux";
import "swiper/css";
import "swiper/css/pagination";
import { createBettoBannerSwiper } from "../shared/createBettoBannerSwiper.js";
import { BANNER, PAGINATION, WRAPPER } from "./elements";

const CASINO_LOBBY_TOP_BANNER = "CasinoLobbyTopBanner";
const LIVE_LOBBY_TOP_BANNER = "LiveLobbyTopBanner";
const AUTOPLAY_DELAY_MS = 5000;

const getContainerName = (activeTab) =>
	activeTab === "LiveCasino" ? LIVE_LOBBY_TOP_BANNER : CASINO_LOBBY_TOP_BANNER;

const BettoLobbyTopBanner = ({ containers, lang, activeTab }) => {
	const swiperRef = useRef(null);
	const swiperContainerRef = useRef(null);
	const paginationRef = useRef(null);

	const containerName = getContainerName(activeTab);

	const banners = useMemo(() => {
		const container = containers?.find((item) => item.name === containerName);
		if (!container?.banners?.length) return [];
		return organizeBanners(container.banners, lang);
	}, [containers, containerName, lang]);

	const canSlide = banners.length > 1;

	useEffect(() => {
		const container = swiperContainerRef.current;
		const pagination = paginationRef.current;

		if (!container || !banners.length) {
			return undefined;
		}

		if (swiperRef.current) {
			swiperRef.current.destroy(true, true);
			swiperRef.current = null;
		}

		swiperRef.current = createBettoBannerSwiper({
			container,
			pagination,
			slideCount: banners.length,
			autoplayDelay: AUTOPLAY_DELAY_MS,
		});

		return () => {
			if (swiperRef.current) {
				swiperRef.current.destroy(true, true);
				swiperRef.current = null;
			}
		};
	}, [banners, canSlide]);

	if (!banners.length) return null;

	return (
		<WRAPPER>
			<BANNER
				innerRef={swiperContainerRef}
				className="betto-lobby-top-banner swiper">
				<div className="swiper-wrapper">
					{banners.map((banner, index) => (
						<div
							key={`betto-lobby-top-${banner.title ?? banner.mobile}-${index}`}
							className="swiper-slide">
							<BannerItem
								bannerName={containerName}
								banner={banner}
								index={index}
							/>
						</div>
					))}
				</div>
			</BANNER>
			{canSlide && (
				<PAGINATION
					innerRef={paginationRef}
					className="betto-lobby-top-pagination"
				/>
			)}
		</WRAPPER>
	);
};

const mapStateToProps = (state) => ({
	containers: state.cms.containerData,
	lang: getActiveLanguage(state.localize).code,
});

export default connect(mapStateToProps)(BettoLobbyTopBanner);
